import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wrong",
  "use": "icon-wrong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wrong\"><path d=\"M280 233.6a32.832 32.832 0 1 0-46.4 46.4L465.6 512 233.6 744a32.832 32.832 0 0 0 46.4 46.4L512 558.4l232 232a32.832 32.832 0 0 0 46.4-46.4L558.4 512l232-232a32.832 32.832 0 0 0-46.4-46.4L512 465.6 280 233.6z\" p-id=\"5424\" fill=\"#f40303\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol